import { required } from '../../utils/validation';

export const TriggerValidations = {
  type: [required('models.trigger.type')]
};

class Serializer {
  normalize = data => {
    return {
      id: data.id,
      type: data.assetInfo.metadata.props.type,
      site: {
        id: data.assetInfo.metadata.props.siteId
      },
      workflow: {
        id: data.assetInfo.metadata.props.workflowId
      },
      criteria: data.criterion
        ? data.criterion.map(criteria => ({
            id: criteria.id,
            operation: criteria.properties.logicalOperation,
            order: +criteria.properties.order,
            type: criteria.properties.type,
            property: criteria.properties.property,
            compareBy: criteria.properties.operation,
            compareTo: {
              id: criteria.properties.value || ''
            }
          }))
        : []
    };
  };

  serialize = trigger => {
    return {
      properties: {
        type: trigger.type,
        siteId: trigger.site.id,
        workflowId: trigger.workflow.id
      },
      criterion: trigger.criteria
        ? trigger.criteria.map((criteria, index) => ({
            order: index,
            ...(index !== 0 ? { logicalOperation: criteria.operation } : {}),
            type: criteria.type,
            property: criteria.property,
            operation: criteria.compareBy,
            value: criteria.compareTo ? criteria.compareTo.id : ''
          }))
        : []
    };
  };
}

export const TriggerSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/trigger/index.js